<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4998 10.0001C12.4998 11.3808 11.3805 12.5001 9.9998 12.5001C8.61908 12.5001 7.4998 11.3808 7.4998 10.0001C7.4998 8.61937 8.61908 7.50008 9.9998 7.50008C11.3805 7.50008 12.4998 8.61937 12.4998 10.0001Z"
      :stroke="color"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.04834 10.0001C3.11023 6.61915 6.2688 4.16675 10.0002 4.16675C13.7315 4.16675 16.8901 6.61918 17.952 10.0001C16.8901 13.381 13.7315 15.8334 10.0002 15.8334C6.2688 15.8334 3.11022 13.381 2.04834 10.0001Z"
      :stroke="color"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  width: {
    type: [String, Number],
    default: "20",
  },
  height: {
    type: [String, Number],
    default: "20",
  },
  color: {
    type: String,
    default: "#003D6A",
  },
  strokeWidth: {
    type: [String, Number],
    default: "2",
  },
});
</script>
